<template>
    <label :for="id" :class="getLabelClass()">{{ label }}</label>
    <div class="p-inputgroup">
        <Select
            v-if="loading"
            loading
            placeholder="Carregando..."
            class="w-full md:w-14rem"
        />
        <Select
            v-else
            :id="id"
            :class="getDropdownClass()"
            :disabled="desabilita"
            :filter="filter"
            :model-value="modelValue"
            :option-label="optionLabel"
            :option-value="optionValue"
            :options="itens"
            @blur="$emit('blur')"
            @update:model-value="updateValue"
        />
    </div>
    <small class="p-error" v-if="temErro">{{ mensagemErro || '&nbsp;' }}</small>
</template>
<script>
import Select from 'primevue/select';

export default {
    components: { Select },
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: false,
            default: '',
        },
        filter: {
            type: Boolean,
            default: false,
        },
        desabilita: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        mensagemErro: {
            type: String,
            default: '',
        },
        temErro: {
            type: Boolean,
            default: false,
        },
        itens: {
            type: Array,
            default: () => [],
        },
        optionLabel: {
            type: [String, Function],
            default: 'label',
        },
        optionValue: {
            type: [String, Function],
            default: 'id',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'blur'],
    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value);
        },
        getDropdownClass() {
            return {
                'p-invalid': this.temErro,
            };
        },
        getLabelClass() {
            return {
                'error-field-label': this.temErro,
                'required': this.required,
            };
        },
    },
};
</script>
